import { render, staticRenderFns } from "./pillGroup.vue?vue&type=template&id=721e15de"
import script from "./pillGroup.vue?vue&type=script&lang=ts"
export * from "./pillGroup.vue?vue&type=script&lang=ts"
import style0 from "./pillGroup.vue?vue&type=style&index=0&id=721e15de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports